import React from 'react';
import {classes} from './SkeletonLineWrapper.st.css';
import {SkeletonLine} from 'wix-ui-tpa/cssVars';

interface SkeletonLineProps {
  size: string;
  dataHook?: string;
}

export const SkeletonLineWrapper = ({size, dataHook}: SkeletonLineProps) => {
  return <SkeletonLine data-hook={dataHook} className={classes[size]} />;
};
